import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useProductBrain } from '../../contexts/ProductBrainContext';
import { entityPath } from '../../lib/productInsights';

export function PageHeading({ eyebrow, title, children, action }) {
  return <header className="v2-heading"><div><div className="v2-eyebrow">{eyebrow || 'SPCC / PRODUCT WORKSPACE'}</div><h1>{title}</h1>{children && <p>{children}</p>}</div>{action}</header>;
}
export function BrainStatus() {
  const { loading, errors, refresh } = useProductBrain();
  if (loading) return <p role="status" className="v2-muted">Updating your product context…</p>;
  if (!Object.keys(errors).length) return null;
  return <div className="v2-error" role="alert"><strong>Some product data could not be loaded.</strong><p>{Object.entries(errors).map(([name, error]) => `${name}: ${error}`).join('; ')}</p><button onClick={refresh}>Try again</button></div>;
}
export function RecordLink({ type, record }) {
  return record ? <Link className="v2-record-link" to={entityPath(type, record.id)}>{record.title || record.statement || record.content || record.id}</Link> : <span className="v2-muted">Not linked</span>;
}
export function EmptyState({ title, children, starter }) {
  return <div className="v2-empty"><h2>{title}</h2><p>{children}</p>{starter && <button type="button" className="v2-button secondary" onClick={starter.onStart}>{starter.label}</button>}</div>;
}
export function Field({ label, children, ...props }) {
  return <label className="v2-field"><span>{label}</span>{children || <input {...props} />}</label>;
}
export function SaveButton({ busy, children = 'Save' }) {
  return <button className="v2-button" type="submit" disabled={busy}>{busy ? 'Saving…' : children}</button>;
}
export function AsyncAction({ action, children, className = 'v2-button secondary' }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  return <><button className={className} disabled={busy} onClick={async () => { setBusy(true); setError(''); try { await action(); } catch (e) { setError(e.message); } finally { setBusy(false); } }}>{busy ? 'Working…' : children}</button>{error && <span role="alert" className="v2-error">{error}</span>}</>;
}
const ANSWER_LABELS = {facts:'Stored facts',calculations:'Calculated values',inferences:'AI interpretation',recommendations:'Recommended next steps'};
// Renders a grounded copilot answer; every claim links back to its records.
export function AIAnswer({ answer, data }) {
  return Object.entries(ANSWER_LABELS).map(([key,label]) => answer[key]?.length > 0 && <section key={key}><h3>{label}</h3>{answer[key].map((claim,i) => <div key={i}><p>{claim.text}</p><div className="v2-citations">{claim.references.map(ref => <Link key={`${ref.type}:${ref.id}`} to={entityPath(ref.type,ref.id)}>{data[ref.type]?.find(r => r.id === ref.id)?.title || ref.type}</Link>)}</div></div>)}</section>);
}
